import React, { FC } from "react";
import { useNavigate } from "react-router";
import { Product } from "@/services/ApiOps";
import { getImageURL } from "@/services/FirebaseTools";
import { useQuery } from "react-query";
import { ping } from "ldrs";

interface IPProps {
  item: Product;
  paginatedProducts?: Product[];
}

// Custom hook for image fetching
const useProductImage = (imagePath: string) => {
  return useQuery({
    queryKey: ["productImage", imagePath],
    queryFn: async () => {
      try {
        return await getImageURL(imagePath);
      } catch (error) {
        console.error("Error fetching image:", error);
        return "/fallback-image.png";
      }
    },
    staleTime: Infinity, // Image URLs don't change often
    cacheTime: 24 * 60 * 60 * 1000, // Cache for 24 hours
  });
};

export const IndividualProduct: FC<IPProps> = ({ item }) => {
  ping.register();
  const navigate = useNavigate();
  const { data: imageUrl, isLoading } = useProductImage(item.imagem);

  return (
    <button
      draggable={false}
      key={item.id_produto}
      className="cursor-pointer select-none rounded-lg border border-gray-300 bg-white p-4 text-center transition-all hover:scale-105 hover:shadow-lg active:scale-100 active:shadow-none"
      onClick={() => navigate(`/portfolio/${item.id_produto}`)}
    >
      {!isLoading && imageUrl ? (
        <img
          draggable={false}
          src={imageUrl}
          alt={item.nome}
          className="mb-4 h-44 w-full object-contain"
        />
      ) : (
        <div className="mb-4 flex h-44 w-full items-center justify-center">
          <l-ping
            size="40"
            stroke="5"
            stroke-length="0.25"
            bg-opacity="0.1"
            speed="0.8"
            color="black"
          />
        </div>
      )}
      <h3 className="font-medium text-gray-800">{item.nome}</h3>
    </button>
  );
};
